import { Navigate } from 'react-router-dom'
import { useAuthState } from '../AuthProvider'
import { useRole } from '../../providers/RoleProvider'
import LoadingOverlay from '../../components/LoadingOverlay'

export default function AuthenticatedRoute({ children }: WithChildren) {
  const { isAuthenticated, isLoading } = useAuthState()
  const { loading: roleLoading } = useRole()

  if (isLoading || roleLoading) return <LoadingOverlay />
  if (!isAuthenticated) return <Navigate to="/login" />
  return children
}
